<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import DispatchLogViewer from '../components/DispatchLogViewer.vue';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const campaignId = computed(() => route.params.campaignId);
const accountId = computed(() => route.params.accountId);
const viewerKey = computed(
  () => `${accountId.value || 'account'}-${campaignId.value || 'campaign'}`
);

const handleBack = () => {
  router.push({
    name: 'campaigns_api_index',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="flex flex-col h-full bg-n-white dark:bg-n-slate-1">
    <div class="flex items-center gap-3 p-5 border-b border-n-slate-6">
      <Button
        variant="ghost"
        size="sm"
        color="slate"
        icon="i-lucide-arrow-left"
        label="Voltar"
        class="shrink-0"
        @click="handleBack"
      />
      <div class="h-5 w-px bg-n-slate-6" />
      <h1 class="text-lg font-semibold text-n-slate-12">
        {{ t('CAMPAIGN.ENHANCED.SECTIONS.DISPATCH_LOG') }}
      </h1>
    </div>

    <div class="flex-1 overflow-y-auto p-6">
      <div class="max-w-6xl mx-auto">
        <DispatchLogViewer
          :key="viewerKey"
          :campaign-id="campaignId"
          :account-id="accountId"
        />
      </div>
    </div>
  </div>
</template>
